export default __webpack_public_path__ + "video/mock-video.mp4";